import normalizeURL from './url'
import { RENDER_URL, WORKERS_BASE_URL, LEGACY_WORKERS_BASE_URL } from '../../constants/app'

//already-rendered image hosts + direct image files must not be wrapped
//in our /render proxy — it parses HTML for og:image and 404s on images
const DIRECT = [WORKERS_BASE_URL, LEGACY_WORKERS_BASE_URL, 'rdl.ink', 'api.raindrop.io']

export default function(url='') {
    let finalURL = normalizeURL(url)
    if (!finalURL)
        return ''

    if (DIRECT.some(h => finalURL.includes(h)))
        return finalURL.replace(/width=\d+/, 'a')

    if (/\.(png|jpe?g|webp|gif|avif|svg)(\?.*|#.*|$)/i.test(finalURL))
        return finalURL

    return RENDER_URL+'/'+encodeURIComponent(finalURL)
}